"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainIdToChainName = exports.triaAuthUrl = exports.TRIA_WALLET_SELECTED_CHAIN = exports.TRIA_WALLET_STORE = exports.eventTypes = void 0;
exports.eventTypes = {
    logIn: 'Log in',
    triaSignUp: 'Tria Sign up',
    socialSignUp: 'Social Sign up',
    signMessage: 'Sign Message',
    send: 'Send',
    disconnect: 'Disconnect',
    switchChain: 'Switch chain',
    detected: 'Detected Logged in Tria account',
    logout: 'Logout',
    passMessage: 'Pass Message',
    accessToken: 'Access Token Pass',
    idTokenPass: 'Id Token Pass',
    saveToAuth: 'Save to Auth Iframe',
};
exports.TRIA_WALLET_STORE = 'tria.wallet.store';
exports.TRIA_WALLET_SELECTED_CHAIN = 'tria.wallet.selectedChain';
exports.triaAuthUrl = 'https://auth.tria.so';
// export const PARENT_URL = document?.referrer || window?.parent?.[0]?.location?.ancestorOrigins?.[0];
exports.chainIdToChainName = {
    80001: 'MUMBAI',
    137: 'POLYGON',
    1: 'ETH',
    43114: 'AVALANCHE',
    42161: 'ARBITRUM',
    56: 'BINANCE',
    10: 'OPTIMISM',
    250: 'FANTOM',
    122: 'FUSE',
    5000: 'MANTLE',
    5001: 'MANLT-TESTNET',
    1088: 'METIS',
    599: 'METIS-TESTNET',
    169: 'MANTA',
    3441005: 'MANTA-TESTNET',
};
